// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=js"
// @generated from file console/admin/v1/vehicle_data.proto (package console.admin.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file console/admin/v1/vehicle_data.proto.
 */
export const file_console_admin_v1_vehicle_data: GenFile = /*@__PURE__*/
  fileDesc("CiNjb25zb2xlL2FkbWluL3YxL3ZlaGljbGVfZGF0YS5wcm90bxIQY29uc29sZS5hZG1pbi52MSKmAwoQVmVoaWNsZURhdGFCdWlsZBIKCgJpZBgBIAEoCRIPCgdyZWxlYXNlGAIgASgJEg8KB3RyaWdnZXIYAyABKAkSGQoRcmVxdWVzdGVkX2J5X25hbWUYBCABKAkSDgoGc3RhdHVzGAUgASgJEgwKBHN0ZXAYBiABKAkSLgoKc3RhcnRlZF9hdBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLwoLZmluaXNoZWRfYXQYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhQKDHB1Ymxpc2hlZF9pZBgJIAEoCRIVCg1nel9zaXplX2J5dGVzGAogASgEEhUKDWRiX3NpemVfYnl0ZXMYCyABKAQSEQoJZGJfc2hhMjU2GAwgASgJEhMKC2dvbGRlbl92aW5zGA0gASgNEhMKC2dvbGRlbl9yb3dzGA4gASgNEg0KBWVycm9yGA8gASgJEhAKCHByb2JsZW1zGBAgAygJEhQKDGRvd25sb2FkYWJsZRgRIAEoCBISCgpyZWxlYXNlX2lkGBIgASgJIhcKFUdldFZlaGljbGVEYXRhUmVxdWVzdCKtAgoWR2V0VmVoaWNsZURhdGFSZXNwb25zZRI1CglwdWJsaXNoZWQYASABKAsyIi5jb25zb2xlLmFkbWluLnYxLlZlaGljbGVEYXRhQnVpbGQSNAoIYnVpbGRpbmcYAiABKAsyIi5jb25zb2xlLmFkbWluLnYxLlZlaGljbGVEYXRhQnVpbGQSLgoKY2hlY2tlZF9hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASFgoObGF0ZXN0X3JlbGVhc2UYBCABKAkSEwoLY2hlY2tfZXJyb3IYBSABKAkSGQoRYnVpbGRlcl9jb25uZWN0ZWQYBiABKAgSFwoPZGV2aWNlc19jdXJyZW50GAcgASgNEhUKDWRldmljZXNfdG90YWwYCCABKA0iSgoRTGlzdEJ1aWxkc1JlcXVlc3QSEQoJcGFnZV9zaXplGAEgASgNEhIKCnBhZ2VfdG9rZW4YAiABKAkSDgoGb2Zmc2V0GAMgASgNInAKEkxpc3RCdWlsZHNSZXNwb25zZRIyCgZidWlsZHMYASADKAsyIi5jb25zb2xlLmFkbWluLnYxLlZlaGljbGVEYXRhQnVpbGQSFwoPbmV4dF9wYWdlX3Rva2VuGAIgASgJEg0KBXRvdGFsGAMgASgNIhUKE1JlcXVlc3RCdWlsZFJlcXVlc3QiSQoUUmVxdWVzdEJ1aWxkUmVzcG9uc2USMQoFYnVpbGQYASABKAsyIi5jb25zb2xlLmFkbWluLnYxLlZlaGljbGVEYXRhQnVpbGQysQIKElZlaGljbGVEYXRhU2VydmljZRJjCg5HZXRWZWhpY2xlRGF0YRInLmNvbnNvbGUuYWRtaW4udjEuR2V0VmVoaWNsZURhdGFSZXF1ZXN0GiguY29uc29sZS5hZG1pbi52MS5HZXRWZWhpY2xlRGF0YVJlc3BvbnNlElcKCkxpc3RCdWlsZHMSIy5jb25zb2xlLmFkbWluLnYxLkxpc3RCdWlsZHNSZXF1ZXN0GiQuY29uc29sZS5hZG1pbi52MS5MaXN0QnVpbGRzUmVzcG9uc2USXQoMUmVxdWVzdEJ1aWxkEiUuY29uc29sZS5hZG1pbi52MS5SZXF1ZXN0QnVpbGRSZXF1ZXN0GiYuY29uc29sZS5hZG1pbi52MS5SZXF1ZXN0QnVpbGRSZXNwb25zZWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message console.admin.v1.VehicleDataBuild
 */
export type VehicleDataBuild = Message<"console.admin.v1.VehicleDataBuild"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * NHTSA's release, e.g. `2026_09`.
   *
   * @generated from field: string release = 2;
   */
  release: string;

  /**
   * `schedule` (the nightly check) or `staff`.
   *
   * @generated from field: string trigger = 3;
   */
  trigger: string;

  /**
   * For a staff request, who asked.
   *
   * @generated from field: string requested_by_name = 4;
   */
  requestedByName: string;

  /**
   * `building`, `published`, or `failed`.
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * While building: `fetch`, `restore`, `copy`, `finalize`, `validate`,
   * `golden`, or `compress`. Empty before the builder reports.
   *
   * @generated from field: string step = 6;
   */
  step: string;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 7;
   */
  startedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 8;
   */
  finishedAt?: Timestamp | undefined;

  /**
   * Once built.
   *
   * @generated from field: string published_id = 9;
   */
  publishedId: string;

  /**
   * @generated from field: uint64 gz_size_bytes = 10;
   */
  gzSizeBytes: bigint;

  /**
   * @generated from field: uint64 db_size_bytes = 11;
   */
  dbSizeBytes: bigint;

  /**
   * @generated from field: string db_sha256 = 12;
   */
  dbSha256: string;

  /**
   * Golden VINs checked against NHTSA's own decoder, and the Pattern rows
   * they matched.
   *
   * @generated from field: uint32 golden_vins = 13;
   */
  goldenVins: number;

  /**
   * @generated from field: uint32 golden_rows = 14;
   */
  goldenRows: number;

  /**
   * For a failed build: what went wrong, and each problem a check found.
   *
   * @generated from field: string error = 15;
   */
  error: string;

  /**
   * @generated from field: repeated string problems = 16;
   */
  problems: string[];

  /**
   * The file is still stored (the newest three published builds), so staff
   * can download it at `/staff/vehicle-data/<published_id>/vpic.lite.db.gz`.
   *
   * @generated from field: bool downloadable = 17;
   */
  downloadable: boolean;

  /**
   * The build's encrypted release (ContentService), which tablets that can
   * open it fetch in place of the plain file. A build is published only once
   * its release is ready.
   *
   * @generated from field: string release_id = 18;
   */
  releaseId: string;
};

/**
 * Describes the message console.admin.v1.VehicleDataBuild.
 * Use `create(VehicleDataBuildSchema)` to create a new message.
 */
export const VehicleDataBuildSchema: GenMessage<VehicleDataBuild> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_vehicle_data, 0);

/**
 * @generated from message console.admin.v1.GetVehicleDataRequest
 */
export type GetVehicleDataRequest = Message<"console.admin.v1.GetVehicleDataRequest"> & {
};

/**
 * Describes the message console.admin.v1.GetVehicleDataRequest.
 * Use `create(GetVehicleDataRequestSchema)` to create a new message.
 */
export const GetVehicleDataRequestSchema: GenMessage<GetVehicleDataRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_vehicle_data, 1);

/**
 * @generated from message console.admin.v1.GetVehicleDataResponse
 */
export type GetVehicleDataResponse = Message<"console.admin.v1.GetVehicleDataResponse"> & {
  /**
   * The build devices are offered. Absent before the first one is published.
   *
   * @generated from field: console.admin.v1.VehicleDataBuild published = 1;
   */
  published?: VehicleDataBuild | undefined;

  /**
   * The build in progress, if any.
   *
   * @generated from field: console.admin.v1.VehicleDataBuild building = 2;
   */
  building?: VehicleDataBuild | undefined;

  /**
   * The nightly check: when it last ran, the newest release NHTSA listed
   * then, and why it could not read NHTSA's page, if it could not.
   *
   * @generated from field: google.protobuf.Timestamp checked_at = 3;
   */
  checkedAt?: Timestamp | undefined;

  /**
   * @generated from field: string latest_release = 4;
   */
  latestRelease: string;

  /**
   * @generated from field: string check_error = 5;
   */
  checkError: string;

  /**
   * Whether this console can reach its builder; false means builds cannot run.
   *
   * @generated from field: bool builder_connected = 6;
   */
  builderConnected: boolean;

  /**
   * Active, assigned devices whose last report names the published build, of
   * all active, assigned devices.
   *
   * @generated from field: uint32 devices_current = 7;
   */
  devicesCurrent: number;

  /**
   * @generated from field: uint32 devices_total = 8;
   */
  devicesTotal: number;
};

/**
 * Describes the message console.admin.v1.GetVehicleDataResponse.
 * Use `create(GetVehicleDataResponseSchema)` to create a new message.
 */
export const GetVehicleDataResponseSchema: GenMessage<GetVehicleDataResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_vehicle_data, 2);

/**
 * @generated from message console.admin.v1.ListBuildsRequest
 */
export type ListBuildsRequest = Message<"console.admin.v1.ListBuildsRequest"> & {
  /**
   * @generated from field: uint32 page_size = 1;
   */
  pageSize: number;

  /**
   * From the previous page's next_page_token; empty for the first.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * Rows to skip, for a numbered page. Used in place of `page_token`.
   *
   * @generated from field: uint32 offset = 3;
   */
  offset: number;
};

/**
 * Describes the message console.admin.v1.ListBuildsRequest.
 * Use `create(ListBuildsRequestSchema)` to create a new message.
 */
export const ListBuildsRequestSchema: GenMessage<ListBuildsRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_vehicle_data, 3);

/**
 * @generated from message console.admin.v1.ListBuildsResponse
 */
export type ListBuildsResponse = Message<"console.admin.v1.ListBuildsResponse"> & {
  /**
   * Newest first.
   *
   * @generated from field: repeated console.admin.v1.VehicleDataBuild builds = 1;
   */
  builds: VehicleDataBuild[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * How many builds there are, across every page.
   *
   * @generated from field: uint32 total = 3;
   */
  total: number;
};

/**
 * Describes the message console.admin.v1.ListBuildsResponse.
 * Use `create(ListBuildsResponseSchema)` to create a new message.
 */
export const ListBuildsResponseSchema: GenMessage<ListBuildsResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_vehicle_data, 4);

/**
 * @generated from message console.admin.v1.RequestBuildRequest
 */
export type RequestBuildRequest = Message<"console.admin.v1.RequestBuildRequest"> & {
};

/**
 * Describes the message console.admin.v1.RequestBuildRequest.
 * Use `create(RequestBuildRequestSchema)` to create a new message.
 */
export const RequestBuildRequestSchema: GenMessage<RequestBuildRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_vehicle_data, 5);

/**
 * @generated from message console.admin.v1.RequestBuildResponse
 */
export type RequestBuildResponse = Message<"console.admin.v1.RequestBuildResponse"> & {
  /**
   * @generated from field: console.admin.v1.VehicleDataBuild build = 1;
   */
  build?: VehicleDataBuild | undefined;
};

/**
 * Describes the message console.admin.v1.RequestBuildResponse.
 * Use `create(RequestBuildResponseSchema)` to create a new message.
 */
export const RequestBuildResponseSchema: GenMessage<RequestBuildResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_vehicle_data, 6);

/**
 * The VIN decoding database tablets download, as MotionSafe staff see it:
 * what is published, what is building, what NHTSA last listed, and every
 * build. The console builds it on its own (a nightly check starts a build
 * when NHTSA lists a new monthly release); RequestBuild starts one now.
 * Staff only. Read-only staff may call the Get and List calls.
 *
 * @generated from service console.admin.v1.VehicleDataService
 */
export const VehicleDataService: GenService<{
  /**
   * @generated from rpc console.admin.v1.VehicleDataService.GetVehicleData
   */
  getVehicleData: {
    methodKind: "unary";
    input: typeof GetVehicleDataRequestSchema;
    output: typeof GetVehicleDataResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.VehicleDataService.ListBuilds
   */
  listBuilds: {
    methodKind: "unary";
    input: typeof ListBuildsRequestSchema;
    output: typeof ListBuildsResponseSchema;
  },
  /**
   * Reads which release NHTSA lists now, then builds it, even if it is the
   * one published: a rebuild of a published release is a new file, which
   * every device then downloads. Refused while a build is running. Audited
   * as `vehicle_data.build_started`.
   *
   * @generated from rpc console.admin.v1.VehicleDataService.RequestBuild
   */
  requestBuild: {
    methodKind: "unary";
    input: typeof RequestBuildRequestSchema;
    output: typeof RequestBuildResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_console_admin_v1_vehicle_data, 0);

